// removed by extract-text-webpack-plugin
module.exports = {"root":"Record--root--3l","tracked":"Record--tracked--1Z","accessory":"Record--accessory--2g","icon":"Record--icon--3D","main":"Record--main--1i","name":"Record--name--3B","nameName":"Record--nameName--CQ","points":"Record--points--1K","objectives":"Record--objectives--Ra","description":"Record--description--3i","small":"Record--small--23","trackButton":"Record--trackButton--1-","completed":"Record--completed--2-","trackButtonBg":"Record--trackButtonBg--RW","trackButtonFg":"Record--trackButtonFg--2F","spin":"Record--spin--vs","tick":"Record--tick--1f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Record/styles.styl
// module id = 803
// module chunks = 0